module.exports = __webpack_public_path__ + "img/20_89.95a33a67.png";